module.exports = __webpack_public_path__ + "img/239.422a5033.jpg";